import './add-fields-group-edit-modal.tag'
riot.tag2('add-fields-groups', '  <catalog object="CustomFieldGroup" cols="{cols}" filters="{filters}" add="{permission(addEdit, &quot;settings&quot;, &quot;0100&quot;)}" remove="{permission(remove, &quot;settings&quot;, &quot;0001&quot;)}" dblclick="{permission(addEdit, &quot;settings&quot;, &quot;1010&quot;)}" reload="true" disable-limit="true" disable-col-select="true" disable-pagination="true">\n    <yield to="body">\n      <datatable-cell name="name">{row.name}</datatable-cell>\n    </yield>\n  </catalog>\n', '', '', function(opts) {
'use strict';

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var self = this;

self.mixin('permissions');
self.mixin('remove');
self.collection = 'CustomFieldGroup';

self.filters = [{
    field: 'data',
    value: opts.type
}];

self.addEdit = function (e) {
    var id = void 0;

    if (e.item && e.item.row) id = e.item.row.id;

    modals.create('add-fields-group-edit-modal', {
        type: 'modal-primary',
        id: id,
        submit: function submit() {
            var _this = this;
            _this.error = _this.validation.validate(_this.item, _this.rules);
            var item = _this.item;

            if (opts.type) item = (0, _extends3.default)({}, this.item, { data: opts.type });

            if (!_this.error) {
                API.request({
                    object: 'CustomFieldGroup',
                    method: 'Save',
                    data: item,
                    success: function success(response) {
                        popups.create({
                            title: 'Успех!',
                            text: 'Дополнительное поле сохранено!',
                            style: 'popup-success'
                        });
                        _this.modalHide();
                        self.tags.catalog.reload();
                    }
                });
            }
        }
    });
};

self.cols = [{ name: 'name', value: 'Наименование' }];
});


// WEBPACK FOOTER //
// ./pages/settings/add-fields/add-fields-groups.tag